import React from 'react';

import { useVideos } from '../providers/VideoContext';
import { useTranslate } from '../hooks/useTranslate';

const VideoSearch: React.FC = () => {
  const { searchQuery, search, clearSearch } = useVideos();
  const { t } = useTranslate();

  const hasQuery = searchQuery.trim().length > 0;

  return (
    <div className="video-search">
      <label className="video-search-label" htmlFor="alamiretv-video-search">
        {t('search.label')}
      </label>
      <div className="video-search-row">
        <input
          id="alamiretv-video-search"
          className="video-search-input"
          type="search"
          autoComplete="off"
          placeholder={t('search.placeholder')}
          value={searchQuery}
          onChange={(e) => search(e.target.value)}
          aria-label={t('search.placeholder')}
        />
        {hasQuery && (
          <button
            type="button"
            className="video-search-clear"
            onClick={clearSearch}
          >
            {t('search.clear')}
          </button>
        )}
      </div>
    </div>
  );
};

export default VideoSearch;
